<template>
    <div class="table-container" v-if="productConfig">
        <table id="offer_table" class="table" @click="goToSpotOffers($event)">
            <thead v-if="Object.keys(lowestOffersPerTerminalAndNetwork).length > 0">
                <tr>
                    <th>Terminals</th>
                    <th v-for="fuel in pagedSpotTableData" :key="fuel._id">{{getProductName(fuel._id)}}</th>
                    <th v-if="showOrderCaptureInfo"></th>
                </tr>
            </thead>   
            <tbody class="hover-grey">
                <tr v-if="getPrices.length < 1">
                    <td class="px-0">
                        <div class="alert tables-alert-custom-message-notify mt-3 text-center">
                            <i class="fas fa-info-circle mr-2"></i>
                            Offers will not be displayed to buyers until Settlement Prices have been updated. Click on {{ settlementPricesButtonText }} to update Settlement Prices
                        </div>
                    </td>     
                </tr> 
                <tr v-else-if="Object.keys(lowestOffersPerTerminalAndNetwork).length < 1">
                    <td class="px-0" colspan="4">
                        <div class="alert tables-alert-custom-message-notify mt-3 text-center">
                            <i class="fas fa-info-circle mr-2"></i>You have not created any offers for this market
                        </div>                        
                    </td>
                </tr>
                <tr v-else v-for="(products, terminalOrNetworkId) in lowestOffersPerTerminalAndNetwork" :key="terminalOrNetworkId" @click="goToSpotOffers()">
                    <td><strong>{{networkAndTerminalNames[terminalOrNetworkId]}}</strong></td>
                    <td v-for="fuel in pagedSpotTableData" :key="fuel._id">
                      <span v-if='products[fuel._id] != null'>
                        {{products[fuel._id] | priceformat}}
                      </span>
                      <span v-else>
                        &ndash;.&mdash;
                      </span>
                    </td>
                    <td v-if="showOrderCaptureInfo"> <button type="button" class="btn btn-link" @click="goToOrderCapture($event, terminalOrNetworkId)"> View </button> </td>
                </tr>
            </tbody>
        </table>
      <el-row type="flex" justify="center" class="pb-2">
        <div>
          <el-button class="pt-2 btn btn-text" @click="previousPage" :key="page" :disabled="page == 1"
            ><i class="fas fa-lg fa-chevron-left mr-2"></i> Previous {{ page == 1 ? 0 : pageSize }} Products
          </el-button>
        </div>
        <div style="padding-top: 1px">
          <el-pagination
            small
            layout="pager"
            :current-page="page"
            :page-size="pageSize"
            @current-change="setPage"
            :total="getFilteredFuels.length"
          >
          </el-pagination>
        </div>
        <div>
          <el-button class="pt-2 btn btn-text" @click="nextPage" :key="page" :disabled="page === getPageCount"
            >Next {{ getNextPageCount }} Products <i class="fas fa-lg fa-chevron-right ml-2"></i
          ></el-button>
        </div>
      </el-row>
    </div>
</template>


<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { _checkOffersAvailabilitySetting } from '@/util/offers.js';
import { getStraightProductId } from "@/util/products";
import { getCustomerSpotOffers } from "@/api/offers";

export default {
    data: function() {
      return {
        networkAndTerminalNames: {},
        buyerOffers: [],
        pageSize: 3,
        page: 1,
      };
    },
    props:{
      selectedCustomer: {
        required: false,
        type: Object,
        default: () => {},
      },
    },
    watch:{
      selectedCustomer:{
        async handler(val){
          if(val && val.id){
            this.buyerOffers = await getCustomerSpotOffers(this.accountId, val.id);
          } else {
            this.buyerOffers = [];
          }
        },
      }
    },
    mounted: async function(){
      if(this.selectedCustomer.id){
        this.buyerOffers = await getCustomerSpotOffers(this.accountId, this.selectedCustomer.id);
      }
    },
    computed: {
        ...mapState('sellerOffers', ['liveTerminalPrices', 'offersAvailability']),
        ...mapGetters('fuelsType', ['getFuelsType', 'getSpotFuels']),
        ...mapGetters('login', ['getIsOrderCaptureEnabledForUser', 'accountId', 'isPricingEngineEnabled']),
        ...mapGetters('livePrices',['getPrices', 'settlementPricesButtonText']),
        ...mapGetters('metadata', ['productConfig', 'networkConfig', 'networks']),
        pagedSpotTableData() {
          let data = this.getFilteredFuels;
          if (data && data.length > 0) {
            return data.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
          }
          return [];
        },
        getPageCount() {
          return Math.ceil(this.getFilteredFuels.length / this.pageSize);
        },
        getNextPageCount() {
          if (this.page < this.getPageCount - 1) {
            return this.pageSize;
          } else if (this.page === this.getPageCount) {
            return 0;
          } else {
            return this.getFilteredFuels.slice(
              this.pageSize * this.getPageCount - this.pageSize,
              this.pageSize * this.getPageCount
            ).length;
          }
        },
        getFilteredFuels() {
          return this.getFuelsType.filter(f => {
            if ((Object.values(this.productConfig).indexOf(f._id) > -1) && (f.type !== "NOT4SALE")) {
              return f
            }
          }
          )
        },
        lowestOffersPerTerminalAndNetwork: function() {
          const spotOffers = this.showOrderCaptureInfo ? this.buyerOffers : this.liveTerminalPrices;
          return this.filterOffers(spotOffers);
        },
        showOrderCaptureInfo:{
          get: function(){
            return this.buyerOffers.length > 0 && this.getIsOrderCaptureEnabledForUser
          }
        }
    },
    methods: {
        ...mapActions('sellerTabs',['selectTab']),
        ...mapActions('terminals',['getTerminalFromId']),
        ...mapActions('orderCapture', ['setCustomer', 'setTerminal', 'setAllSpotProducts', 'setCurrentTab']),
        setPage(val) {
          this.page = val;
        },
        nextPage() {
          if (this.page >= 1) {
            this.page = this.page + 1;
          }
        },
        previousPage() {
          if (this.page <= this.getPageCount) {
            this.page = this.page - 1;
          }
        },
        filterOffers: function(spotOffers){
          if (spotOffers.length < 1 || this.getPrices.length < 1 || !this.offersAvailability || !_checkOffersAvailabilitySetting("SPOT")) {
            return {};
          }
          const productColumns = Object.values(this.productConfig);
          const offerLowestPriceMap = {};
            // Iterate through every offer, ensuring we are mapping the lowest price
            for (const offer of spotOffers) {
              const { terminal_id, networkId, fuel_id, type_id, price, livePrice, terminal, network } = offer;
              const productId = getStraightProductId(this.productConfig, fuel_id);

              // Only map prices for Diesel, Gasoil and Kero
              if (productColumns.includes(productId)) {
                let currentPrice;
                if(this.showOrderCaptureInfo){
                  currentPrice = price;
                } else{
                  currentPrice = (type_id == 'FIXED' || this.isPricingEngineEnabled) ? price : livePrice;
                }
                const terminalOrNetworkId = terminal_id || networkId;

                // Unique terminal or network not saved to map yet?
                if (!offerLowestPriceMap[terminalOrNetworkId])
                  offerLowestPriceMap[terminalOrNetworkId] = {};

                // Map unique Terminal Or Network Ids with their names
                if (!this.networkAndTerminalNames[terminalOrNetworkId]) 
                  this.updateNetworkAndTerminalNames(terminalOrNetworkId, terminal, network);

                // Ensuring we always store the lowest possible offer price for each terminal/network & product combination
                const currentMappedProductPrice = offerLowestPriceMap[terminalOrNetworkId][productId];
                if (!currentMappedProductPrice || currentMappedProductPrice > currentPrice)
                  offerLowestPriceMap[terminalOrNetworkId][productId] = currentPrice;
              }
            }
          return offerLowestPriceMap;
        },
        goToSpotOffers: function(){
          if(!this.showOrderCaptureInfo){
            /* Go to Manage Offers and select Spot tab */
            this.selectTab({ tabIndex:0, type:'Spot' }) 
            if(this.getPrices.length === 0) this.$store.dispatch("livePrices/editSettlementPrices"); 
            this.$router.push({ name: 'manageOffers' })
            //if router.push is 'manageOffers/spot' it duplicates manageOffers url and results in blank page
          }
        },
        goToOrderCapture: async function(event, terminalId){
          event.srcElement.disabled = true;

          this.setCurrentTab('SPOT');
          const terminal = await this.getTerminalFromId(terminalId);
          this.setTerminal(terminal);
          this.setCustomer(this.selectedCustomer);
          this.setAllSpotProducts();

          this.$router.push({ name: 'OrderCapture' })
        },
        getProductName(productId) {
          return this.getFuelsType.find(item => item._id === productId).name;
        },
        getNetworkName(networkId) {
          return this.networks.find(n => n._id === networkId).name;
        },
        updateNetworkAndTerminalNames(id, terminal) {
          let name = '';
          if (terminal) 
            name = terminal.name;
          else
            name = this.getNetworkName(id);
          this.networkAndTerminalNames[id] = name;
        }
    }
}
</script>
<style lang="scss" scoped>
  table {
    table-layout: fixed;
    width: 100%;
  }
</style>